package one.healthium.onboarding.navigation

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import com.arkivanov.decompose.extensions.compose.stack.Children
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import one.healthium.onboarding.navigation.screenDefinition.ScreenGroupContent
import one.healthium.onboarding.ui.components.NavigationProgressBar
import one.healthium.onboarding.ui.components.toProgressBarModel
import one.healthium.paywall.ui.scheduler.RemarketingEffect

@Composable
fun OnboardingContent(component: OnboardingComponent) {
    val paywallSet = component.paywallSet
    if (paywallSet != null) {
        RemarketingEffect(offers = paywallSet.remarketingOffers)
    }

    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        var progressBarVisible by remember { mutableStateOf(true) }

        Children(
            modifier = Modifier.fillMaxSize().testTag("onboarding"),
            stack = component.stack,
        ) {
            val child = it.instance
            ScreenGroupContent(
                component = child.component,
                modifier = Modifier.fillMaxSize(),
                onProgressBarShown = { shown ->
                    progressBarVisible = shown
                }
            )
        }

        AnimatedVisibility(
            visible = progressBarVisible,
            enter = fadeIn(animationSpec = tween(durationMillis = 500)),
            exit = fadeOut(animationSpec = tween(durationMillis = 150)),
        ) {
            val stackState by component.stack.subscribeAsState()
            val activeComponent = stackState.active.instance.component
            NavigationProgressBar(
                modifier = Modifier
                    .fillMaxWidth()
                    .statusBarsPadding()
                    .padding(top = 7.dp, bottom = 27.dp)
                    .padding(horizontal = 60.dp),
                groupsCount = component.model.screens.size,
                currentGroupIndex = component.model.screens.indexOf(activeComponent.screenGroup),
                groupPagesCount = activeComponent.screenGroup.screens.size,
                groupCurrentPage = activeComponent.stack.subscribeAsState().value.backStack.size,
                colors = component.model.config?.toProgressBarModel(),
            )
        }
    }
}
